<template>
    <div class="total-amounts-displayer" :class="{ mobile: isMobile }">
        <!-- Selected Operations Counter -->
        <div class="selected-operations-counter">
            {{ `${numberOfOperationsSelected}/${totalNumberOfOperationsToSign}` }}
        </div>
        <div class="totals-wrapper">
            <!-- Total to Sign -->
            <text-block-generic
            :params="{
                label: t('approvals.pendingSignature.step1.footerDisplayer.totalToSign'),
                content: amountFormat(totalAmountToSign, currency)
            }"/>
            <!-- Total to Transfer -->
            <text-block-generic
            :params="{
                label: t('approvals.pendingSignature.step1.footerDisplayer.totalToTransfer'),
                content: amountFormat(totalAmountToTransfer, currency)
            }"/>
        </div>
    </div>
</template>

<script setup>
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
/* Aux */
import { amountFormat } from '@/assets/scripts/amounts'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/**
@totalNumberOfOperationsToSign {Number} - Total number of operations the user can sign
@numberOfOperationsSelected {Number} - Number of operations selected to sign
@totalAmountToTransfer {Number} - Total amount to transfer
@totalAmountToSign {Number} - Total amount to sign
@currency {String}
@isMobile {Boolean}
*/
const props = defineProps({
    totalNumberOfOperationsToSign: Number,
    numberOfOperationsSelected: Number,
    totalAmountToTransfer: Number,
    totalAmountToSign: Number,
    currency: String,
    isMobile: Boolean
})
</script>

<style lang="scss" scoped>
.total-amounts-displayer {
    width: 100%;
    max-width: 508px;
    height: 72px;

    display: flex;
    align-self: center;
    align-items: center;

    .selected-operations-counter {
        width: 64px;
        height: 40px;

        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;

        @include H7-Medium;
        line-height: 16px;
        color: var(--secondary-dark-2);

        border-radius: 8px;
        background-color: var(--secondary-light-3);
        margin-right: 40px;
    }

    .totals-wrapper {
        width: 100%;

        display: flex;
        align-self: center;
        align-items: center;
    }

    &.mobile {
        height: 120px;
        padding: 16px;
        align-items: flex-start;

        .selected-operations-counter {
            margin-right: 16px;
        }

        .totals-wrapper {
            width: 100%;

            display: flex;
            flex-direction: column;

            gap: 12px;
        }
    }
}
</style>
